import moment, { Moment } from 'moment';
import { GetTimelineItemDroppedTimeArgs, getTimelineItemOverlapFreeTimes } from '@modules/timetable';

export const getTimelineItemDroppedTime = ({
  dropTarget,
  duration,
  timelineItems,
  groupId,
}: GetTimelineItemDroppedTimeArgs): { startTime: Moment; endTime: Moment } => {
  let startTime: Moment;
  let endTime: Moment;

  if (dropTarget.classList.contains('time-slot')) {
    const startTimeFromId = dropTarget.id.split('/')[0];
    const endTimeFromId = dropTarget.id.split('/')[1];
    startTime = moment.unix(parseInt(startTimeFromId, 10));
    endTime = moment.unix(parseInt(endTimeFromId, 10));
  } else {
    startTime = moment.unix(parseInt(dropTarget.id, 10));
    endTime = startTime.clone().add(duration, 'h');
  }

  const overlapFreeTimes = getTimelineItemOverlapFreeTimes({
    timelineItems,
    groupId,
    startTime,
    endTime,
    duration,
  });

  startTime = overlapFreeTimes.startTime;
  endTime = overlapFreeTimes.endTime;

  return {
    startTime,
    endTime,
  };
};
